import { render } from 'react-dom';
import 'swiper/css/bundle'; // Swiper CSS

import './style.scss';
import APBPosts from './Components/Frontend/APBPosts';

document.addEventListener('DOMContentLoaded', () => {
	const postsEls = document.querySelectorAll('.wp-block-ap-block-posts');
	postsEls.forEach(postEl => {
		const nonce = JSON.parse(postEl.dataset.nonce);
		const attributes = JSON.parse(postEl.dataset.attributes);
		const { totalPosts } = JSON.parse(postEl.dataset.extra);

		render(<APBPosts nonce={nonce} totalPosts={totalPosts} attributes={attributes} />, postEl);

		postEl?.removeAttribute('data-posts');
		postEl?.removeAttribute('data-attributes');
		postEl?.removeAttribute('data-extra');
	});
});